import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
  FASTAG_PRICING_REQUEST,
  FASTAG_PRICING_SUCCESS,
  FASTAG_PRICING_FAILURE,
  TRANSFER_TAG,
  FETCH_USER_DETAILS_BY_ID,
  ADD_CASHBACK,
  DELETE_CASHBACK,
  RE_ASSIGN_USER,
  TOA_TAG_ORDERS,
  APPROVE_TAG_ORDER,
  UPLOAD_TAG_ORDER,
  GET_USER_ANALYTICS,
} from "./type";

export const submitFastagPricing = (typeId, formData) => async (dispatch) => {
  let url = Config.fastag.uploadPricingRequest;
  if (typeId === 3) {
    url = Config.fastag.markinactive;
  }
  if (typeId === 8 || typeId === 9) {
    url = Config.fastag.bundleApi;
  }
  if (typeId === 10) {
    url = Config.fastag.removeSbiReplacementTags;
  }
  if (typeId === 11) {
    url = Config.fastag.fseBulkMapping;
  }
  if (typeId === 12 || typeId === 13) {
    url = Config.fastag.sbiAgentPortalData;
  }

  dispatch({ type: FASTAG_PRICING_REQUEST });

  try {
    let res;
    if (typeId === 8) {
      res = await callWebService(callTypes.patch, formData, url);
    } else if (typeId === 11) {
      res = await callWebService(
        callTypes.post,
        { file_link: formData.get("file_link") },
        url
      );
    } else if (typeId === 12 || typeId === 13) {
      res = await callWebService(
        callTypes.post,
        {
          file_link: formData.get("file_link"),
          operation: formData.get("operation"),
        },
        url
      );
    } else {
      res = await callWebService(callTypes.post, formData, url);
    }

    if (!res || !res.data) {
      throw new Error("Invalid API response");
    }

    if (res.data.status !== 0) {
      throw {
        response: {
          data: {
            message: res.data.message || "Something went wrong",
          },
        },
      };
    }

    const responseData = res.data || {};

    dispatch({
      type: FASTAG_PRICING_SUCCESS,
      payload: responseData,
    });

    return responseData;
  } catch (error) {
    dispatch({
      type: FASTAG_PRICING_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "An unknown error occurred.",
    });
    throw error;
  }
};

export const transferTagRequest = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fastag.transferTag
  );
  if (res) {
    const { data } = res;
    dispatch({ type: TRANSFER_TAG, payload: data });
    return data;
  }
};

export const fetchUserDetailsById = (userId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.user.getUserDetailsByUserId}?user_id=${userId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: FETCH_USER_DETAILS_BY_ID, payload: data });
    return true;
  }
};

export const addCashbackForFastag = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fastag.addCashback
  );
  if (res) {
    const { data } = res;
    dispatch({ type: ADD_CASHBACK, payload: data });
    return data;
  }
};

export const deleteCashbackForFastag = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fastag.deleteCashback
  );
  if (res) {
    const { data } = res;
    dispatch({ type: DELETE_CASHBACK, payload: data });
    return data;
  }
};

export const reAssignUserForFastag = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fastag.reAssignUser
  );
  if (res) {
    const { data } = res;
    dispatch({ type: RE_ASSIGN_USER, payload: data });
    return data;
  }
};

export const getToaTagOrders = (data, page = 1, id= null) => async (dispatch) => {

  let url = Config.fastag.getToaTagOrders;
  const role_id = Number(localStorage.getItem("fusion-role"));

  let payload = {
    page: page,
    limit: 30,
    source: "toll_coordinator",
    filter: {},
    search: {}
  };

  if (id) {
    payload.search.order_id = id;
  }

  if (data) {
    if (data.status) payload.filter.fulfilment_status = [data.status];
    
    if (data.acquirer && data.acquirer.length > 0) {
      payload.filter.acquirer = Array.isArray(data.acquirer) ? data.acquirer.join(',') : data.acquirer;
    }
    
    if (data.operator_role && data.operator_role.length > 0) {
      payload.filter.operator_role = Array.isArray(data.operator_role) ? data.operator_role.join(',') : data.operator_role;
    }

    if (data.fulfilment_status && data.fulfilment_status.length > 0) {
      payload.filter.fulfilment_status = Array.isArray(data.fulfilment_status) ? data.fulfilment_status.join(',') : data.fulfilment_status;
    }

    if (data.date_from) {
      payload.filter.order_date = data.date_to 
        ? `${data.date_from},${data.date_to}`
        : `${data.date_from},${data.date_from}`; 
    }

    if (data.operator_id) payload.search.operator_id = data.operator_id;
    if (data.operator_phone_number) payload.search.operator_phone_number = data.operator_phone_number;
    if (data.order_id) payload.search.order_id = data.order_id;
  }

  if(!payload.filter.fulfilment_status && role_id != 67){
    payload.filter.fulfilment_status = ["APPROVED","SHIPPED"];
  }

  const res = await callWebService(
    callTypes.post,
    payload,
    url
  );
  
  if (res && res.data.status === 0) {
    const { data } = res.data;
    dispatch({ type: TOA_TAG_ORDERS, payload: data });
    return data;
  } 

};

export const approveTagOrder = (data) => async (dispatch) => {
  dispatch({ type: APPROVE_TAG_ORDER });

  try {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.fastag.approveTagOrder
    );

    if (!res || !res.data) {
      throw new Error("Invalid API response");
    }

    if (res.data.status !== 0) {
      const message =
        res.data.message ||
        "Something went wrong";

      throw new Error(message);
    }

    dispatch({
      type: APPROVE_TAG_ORDER,
      payload: res.data,
    });

    return res.data;

  } catch (error) {

    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "An unknown error occurred.";

    dispatch({
      type: APPROVE_TAG_ORDER,
      payload: errorMessage,
    });

    throw new Error(errorMessage);
  }
};

export const uploadTagOrderCsv = (data) => async (dispatch) => {
  dispatch({ type: UPLOAD_TAG_ORDER });

  try {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.fastag.uploadTagOrderCsv
    );

    if (!res || !res.data) {
      throw new Error("Invalid API response");
    }

    if (res.data.status !== 0) {
      const message =
        res.data.message ||
        "Something went wrong";

      throw new Error(message);
    }

    dispatch({
      type: UPLOAD_TAG_ORDER,
      payload: res.data,
    });

    return res.data;

  } catch (error) {

    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "An unknown error occurred.";

    dispatch({
      type: UPLOAD_TAG_ORDER,
      payload: errorMessage,
    });

    throw new Error(errorMessage);
  }
};

export const getUserAnalytics = (data) => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.fastag.getUserAnalytics
    );
    if (res && res.data.status === 0) {
      const { data } = res.data;
      dispatch({ type: GET_USER_ANALYTICS, payload: data });
      return data;
    }
  } catch (error) {
    console.error("Error fetching user analytics:", error);
  }
};
